import React from 'react'
import 'daterangepicker/daterangepicker.css';
import "./billing_subscriptions_form_modal.scss";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, PaymentElement, AddressElement, ElementsConsumer } from "@stripe/react-stripe-js";
import { BeatLoader } from "react-spinners";
import "./billing_payment_method_form.scss";

const stripePromise = loadStripe(window.STRIPE_PUBLISHABLE_KEY);

export default class AddPaymentMethodForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      clientSecret: null,
      loading: true,
      disabled: false
    }

    this.createSetupIntent().then((clientSecret) => {
      // console.log("Setting Stripe client secret:", clientSecret)
      this.setState({ clientSecret });
    });
  }

  async createSetupIntent() {
    const response = await fetch("/billing/accounts/create_setup_intent", {
      body: JSON.stringify({
        authenticity_token: this.props.authenticity_token
      }),
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const { client_secret } = await response.json();
    return client_secret;
  }

  async handleSave(stripe, elements, event) {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    // event.preventDefault();

    this.setState({ disabled: true });

    const result = await stripe.confirmSetup({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: `${this.props.uiBaseUrl}/billing/accounts/checkout_success`
      },
      redirect: this.props.onAdded ? "if_required" : "always"
    });

    if (result.error) {
      // Show error to your customer (for example, payment details incomplete)
      console.error(result.error.message);
      this.setState({ disabled: false });
      if (this.props.onAdded) {
        this.props.onAdded({ error: result.error.message });
      }
    } else {
      // console.log("Stripe result:", result);

      // Non-redirect logic
      if (this.props.onAdded) {
        let response = await fetch(`/billing/accounts/checkout_success.json?setup_intent=${result.setupIntent.id}`);
        let jsonResponse = await response.json();
        console.log("Payment Method addh success response:", jsonResponse);
        this.props.onAdded(jsonResponse);
      }

    }
  }

  render() {

    const paymentElementOptions = {
      layout: "tabs",
      business: {
        name: "Cloverhound, Inc."
      }
    };

    return (
      <div style={{minHeight: "400"}}>
        {this.state.clientSecret &&
          <div style={{visibility: this.state.loading ? "hidden" : "visible", height: this.state.loading ? "0px" : "auto"}}>
            <Elements stripe={stripePromise} options={{clientSecret: this.state.clientSecret}}>
              <ElementsConsumer>
                {({stripe, elements}) => (
                  <div className="payment-method-modal__container">
                    <h4>Billing Info</h4>
                    <AddressElement id="address-element" options={{mode: "billing"}}  />

                    <h4>Payment Info</h4>
                    <PaymentElement id="payment-element" options={paymentElementOptions} onReady={() => {
                      this.setState({loading: false});
                    }} />

                    <div className="payment-method-modal__button-container" style={{
                      opacity: this.state.loading ? 0 : (this.state.disabled ? 0.5 : 1)
                    }}>
                      <button onClick={this.handleSave.bind(this, stripe, elements)} disabled={this.state.disabled}>
                        Save Payment Method
                      </button>

                      <PoweredByStripeSubtext />
                    </div>

                  </div>
                )}
              </ElementsConsumer>
            </Elements>
          </div>
        }

        {this.state.loading &&
          <PaymentMethodFormLoader />
        }
      </div>
    );

  }

}

function PaymentMethodFormLoader() {
  return (
    <div style={{display: "flex", height: "400px"}}>
      <BeatLoader style={{margin: "120px auto"}} color="#0470de" width="30px" size={10} margin="4px" />
    </div>
  );
}

function PoweredByStripeSubtext() {
  return (
    <div style={{
      display: "flex",
      justifyContent: "end",
      gap: "4px",
      marginTop: "10px",
      marginRight: "2px",
    }}>
        <p style={{
            color: "#6d6e78",
            display: "inline-block",
            fontSize: "1.1rem",
            lineHeight: "inherit",
            margin: 0
        }}>
          Powered by
        </p>
        <a href="https://stripe.com" target="_blank" rel="noreferrer">
            <svg width="34" height="15" viewBox="0 0 28 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={{
                width: "34px",
                height: "15px",
                fill: "#6d6e78"
            }}>
                <path fillRule="evenodd" clipRule="evenodd" d="M13.0267 2.77999L14.8467 2.39999V0.959991L13.0267 1.33999V2.77999ZM5.27999 2.19332L7.04666 1.80666L7.05999 3.41999H8.43332V4.97999H7.05999V7.64666C7.05999 8.75332 8.19999 8.41332 8.43332 8.31332V9.81332C8.03434 9.99503 7.59796 10.0796 7.15999 10.06C6.90898 10.0647 6.65965 10.0181 6.42723 9.92323C6.19481 9.8283 5.98419 9.68699 5.80823 9.50791C5.63228 9.32883 5.49468 9.11576 5.40386 8.88171C5.31304 8.64766 5.27089 8.39755 5.27999 8.14666V2.19332ZM10.7466 3.34L10.86 3.88667C10.9993 3.62898 11.228 3.43115 11.5031 3.33046C11.7782 3.22976 12.0806 3.23315 12.3533 3.34V5.04C12.1132 4.95767 11.8537 4.95058 11.6095 5.01968C11.3653 5.08877 11.148 5.23076 10.9866 5.42667V9.81333H9.19998V3.34H10.7466ZM18.86 3.26667C18.5968 3.26514 18.3359 3.31559 18.0922 3.41512C17.8485 3.51465 17.6269 3.6613 17.44 3.84667L17.3467 3.38667H15.7533V12L17.5667 11.6067V9.52C17.9273 9.82203 18.3829 9.98727 18.8533 9.98667C20.1467 9.98667 21.3333 8.92667 21.3333 6.58C21.3333 4.43333 20.1333 3.26667 18.86 3.26667ZM18.4267 8.35333C18.2676 8.3625 18.1085 8.33615 17.9609 8.27618C17.8133 8.21622 17.6809 8.12416 17.5733 8.00667V5.26667C17.6814 5.14488 17.8153 5.04875 17.9652 4.98532C18.1151 4.92188 18.2773 4.89273 18.44 4.9C19.1067 4.9 19.56 5.65333 19.56 6.62C19.56 7.58666 19.1 8.35333 18.4267 8.35333ZM24.68 3.26666C22.9333 3.26666 21.8733 4.77333 21.8733 6.67333C21.8733 8.92 23.1267 10.06 24.9133 10.06C25.6106 10.0714 26.2992 9.90382 26.9133 9.57333V8.07333C26.3556 8.35473 25.7379 8.49657 25.1133 8.48666C24.3933 8.48666 23.78 8.22666 23.6867 7.35333H27.2733V6.68666C27.3333 4.77333 26.4267 3.26666 24.68 3.26666ZM23.7 5.98C23.7 5.14 24.2133 4.78666 24.6667 4.78666C25.12 4.78666 25.6 5.14 25.6 5.98H23.7ZM1.83333 5.28666C1.83333 4.99333 2.07333 4.88 2.45333 4.88C3.0831 4.89355 3.70041 5.05817 4.25332 5.36V3.60666C3.68167 3.37553 3.06989 3.25997 2.45333 3.26666C0.979997 3.26666 0 4.05333 0 5.37333C0 6.62207 1.00765 6.99459 1.80525 7.28945C2.32768 7.48259 2.75999 7.64241 2.75999 7.99333C2.75999 8.34 2.46666 8.45333 2.09333 8.45333C1.38897 8.41217 0.704031 8.20669 0.0933326 7.85333V9.64666C0.722755 9.9274 1.40414 10.0728 2.09333 10.0733C3.59999 10.0733 4.63998 9.30666 4.63998 7.96666C4.61933 6.57878 3.54682 6.20437 2.73382 5.92056C2.23466 5.74631 1.83333 5.60621 1.83333 5.28666ZM13.0267 3.38666H14.8467V9.81332H13.0267V3.38666Z" />
            </svg>
        </a>
    </div>
  );
}
